function initNavigationMenu() {
    const navToggle = document.querySelector('.nav-toggle');
    if (!navToggle) return;

    navToggle.addEventListener('click', (e) => {
        e.preventDefault()

        const navMain = navToggle.closest('.nav-main');

        if (navMain) {
            const isActive = navMain.classList.toggle('is-active');
            document.body.style.overflow = isActive ? 'hidden' : '';
        }
    });
}